import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const departmentApiUrl = `${baseApiUrl}/api/Departments`;

export async function getDepartments() {
    return await httpRequest(fetchDepartments.bind(this));
}

async function fetchDepartments() {
    let config = getHttpHeaders();
    return await axios.get(`${departmentApiUrl}`, config);
}